export default __webpack_public_path__ + "static/media/css.43b6f4bd.svg";